// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__3_n6J","lds-facebook":"Loading_lds-facebook__3I4kF"};